import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    idToken: null,
    userId: null,
    currentLearnerId: 0,
    currentUserName: '',
    userEmail: '',
    currentLastLogIn: '',
    birdCage: null,
    loggedIn: false,
    userLevel: 0,
    courseChosen: false,
    courseNumber: 1,
  },
  mutations: {
    authUser(state, userData) {
      state.idToken = userData.token;
      state.userId = userData.userId;
      state.currentUserName = userData.userName;
      state.currentLastLogIn = userData.lastLogIn;
      state.birdCage = userData.birdCage;
      state.loggedIn = true;
      state.userEmail = userData.email_address;
      state.userLevel = userData.userLevel;
    },
    clearAuthData(state) {
      state.idToken = null;
      state.userId = null;
      state.currentUserName = '';
      state.birdCage = null;
      state.loggedIn = false;
      state.userEmail = '';
      state.userLevel = 0;
    },
    selectCourse(state, courseData) {
      state.courseChosen = courseData.course;
    },
    selectCurrentLearner(state, learnerId) {
      state.currentLearnerId = learnerId.learnerId;
    },
    courseNumber(state, numberData) {
      state.courseNumber = numberData.number;
    },
  },
  actions: {
    saveToken({ commit }, authData) {
      commit('authUser', {
        token: authData.token,
        userId: authData.user_id,
        birdCage: authData.cage,
        userName: authData.username,
        lastLogIn: authData.lastlogin,
        email_address: authData.email_address,
        userLevel: authData.userlevel,
      });
      const expirationDate = authData.expiresIn;
      localStorage.setItem('token', authData.token);
      localStorage.setItem('userId', authData.user_id);
      localStorage.setItem('birdCage', authData.cage);
      localStorage.setItem('expiryDate', expirationDate);
      localStorage.setItem('userName', authData.username);
      localStorage.setItem('lastLogIn', authData.lastlogin);
      localStorage.setItem('email_address', authData.email_address);
      localStorage.setItem('userLevel', authData.userlevel);
    },
    checkStoredToken({ commit }) {
      const localToken = localStorage.getItem('token');
      const localUserId = localStorage.getItem('userId');
      const localCage = localStorage.getItem('birdCage');
      const localExpiryDate = localStorage.getItem('expiryDate');
      const localUserName = localStorage.getItem('userName');
      const localLastLogIn = localStorage.getItem('lastLogIn');
      const localEmail = localStorage.getItem('email_address');
      const localUserLevel = localStorage.getItem('userLevel');
      const now = new Date();
      const ts = Math.round((now.getTime() / 1000));
      if (localToken && ts <= localExpiryDate) {
        commit('authUser', {
          token: localToken,
          userId: localUserId,
          birdCage: localCage,
          userName: localUserName,
          lastLogIn: localLastLogIn,
          email_address: localEmail,
          userLevel: localUserLevel,
        });
      }
    },
    logout({ commit }) {
      commit('clearAuthData');
      localStorage.removeItem('token');
      localStorage.removeItem('expiryDate');
      localStorage.removeItem('userId');
      localStorage.removeItem('birdCage');
      localStorage.removeItem('userName');
      localStorage.removeItem('lastLogIn');
      localStorage.removeItem('email_address');
      localStorage.removeItem('userLevel');
    },
    selectCourse({ commit }, course) {
      commit('selectCourse', {
        course,
      });
      localStorage.setItem('chosenCourse', course);
    },
    selectCurrentLearner({ commit }, learnerId) {
      commit('selectCurrentLearner', {
        learnerId,
      });
    },
    courseNumber({ commit }, number) {
      commit('courseNumber', {
        number,
      });
      localStorage.setItem('courseNumber', number);
    },
    checkStoredCourse({ commit }) {
      const localChosenCourse = localStorage.getItem('chosenCourse');
      const localCourseNumber = localStorage.getItem('courseNumber');
      if (localChosenCourse) {
        commit('selectCourse', {
          course: localChosenCourse,
        });
      }
      if (localCourseNumber) {
        commit('courseNumber', {
          number: localCourseNumber,
        });
      }
    },
  },
  getters: {
    isAuthenticated(state) {
      return state.idToken !== null;
    },
    authData(state) {
      const authorizationData = {};
      authorizationData.userId = state.userId;
      authorizationData.cage = state.birdCage;
      authorizationData.token = state.idToken;
      authorizationData.userEmail = state.userEmail;
      return authorizationData;
    },
    userLevel(state) {
      return state.userLevel;
    },
    currentUserName(state) {
      return state.currentUserName;
    },
    currentLearnerId(state) {
      return state.currentLearnerId;
    },
    isLoggedIn(state) {
      return state.loggedIn;
    },
    courseChosen(state) {
      return state.courseChosen;
    },
    courseNumber(state) {
      return state.courseNumber;
    },
  },
});
